import React from "react";
import { motion } from "framer-motion";
import { TileData } from "../../types";
import { PuzzleTile } from "./PuzzleTile";

interface PuzzleGridProps {
  grid: TileData[][];
  liveMap: boolean[][];
  distanceMap: number[][];
  onTileClick: (row: number, col: number) => void;
  won: boolean;
  shaking: boolean;
}

const SHAKING_VARIANTS: any = {
  rest: { x: 0 },
  shake: { x: [0, -8, 8, -6, 6, -4, 4, 0] },
} as const;

export const PuzzleGrid = React.memo(function PuzzleGrid({
  grid,
  liveMap,
  distanceMap,
  onTileClick,
  won,
  shaking,
}: PuzzleGridProps) {
  const gridSize = grid.length;
  const endR = gridSize - 1;
  const endC = gridSize - 1;

  return (
    <motion.div
      className="relative w-full"
      variants={SHAKING_VARIANTS}
      animate={shaking ? "shake" : "rest"}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <div
        className="grid bg-gray-800"
        style={{
          gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
          boxShadow:
            "0 0 40px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
        }}
      >
        {grid.map((row, r) =>
          row.map((tile, c) => (
            <PuzzleTile
              key={`${r}-${c}`}
              tile={tile}
              row={r}
              col={c}
              live={liveMap[r]?.[c] ?? false}
              distance={distanceMap[r]?.[c] ?? 0}
              isSource={r === 0 && c === 0}
              isEnd={r === endR && c === endC}
              onTileClick={onTileClick}
              won={won}
            />
          )),
        )}
      </div>
    </motion.div>
  );
});
